import { BorderGridContainer, GridBox, SpacerWrapper } from '@ahmdigital/ui';
import React from 'react';

import FeaturesSection from '../../../../components/sections/features-section';
import HeaderDescriptionBlock from '../header-description-block';
import pageStyles from '../../styles.module.sass';

type HeaderSectionProps = {
  data: {
    advantages: {};
  };
};

const HeaderSection = ({ data: { advantages, ...headerDescriptionProps } }: HeaderSectionProps) => (
  <BorderGridContainer hideBorderTop>
    <GridBox padding="1rem">
      <div className={pageStyles.horizontalSpacingWrapper}>
        <SpacerWrapper variant={['marginTopSpacer2', 'marginBottomSpacer6']}>
          {/* @ts-expect-error - Automatic, Please fix when editing this file */}
          <HeaderDescriptionBlock {...headerDescriptionProps} />
        </SpacerWrapper>
        {/* @ts-expect-error - Automatic, Please fix when editing this file */}
        <FeaturesSection {...advantages} />
      </div>
    </GridBox>
  </BorderGridContainer>
);

export default HeaderSection;
